// Code generated by scripts/gen-historical-correspondence.py; DO NOT EDIT.
export const archiveSections = [
  {
    "key": "reply_board_presentation",
    "source": "reply_board",
    "title": "ReplyBoardPresentation",
    "fields": [
      {
        "key": "_label",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "_log",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "board",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "chip",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "finding",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "group",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "log_label",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "proof",
        "meaning": "Presentation/evidence list, not independently verified provider proof; no execution of cited paths/URLs."
      },
      {
        "key": "rank",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "section",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "thumb",
        "meaning": "Presentation locator/label only; no byte existence, file kind, ACL or preview permission inferred."
      },
      {
        "key": "tier",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "title",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "reply_board_approval",
    "source": "reply_board",
    "title": "ReplyBoardApproval",
    "fields": [
      {
        "key": "approval_basis",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approval_note",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approval_source",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approved_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approved_body_sha256",
        "meaning": "Recorded approval-body hash assertion; not actual sent-body proof or live approval. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approved_quote",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "approved_via",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "ben_send_word",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "ben_send_word_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "ben_send_word_at_superseded",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "ben_send_word_superseded",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "cancelled_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "cancelled_on_authority_of",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "harness_override",
        "meaning": "Archive words/codes and unknown object keys; do not evaluate original harness or confer any override authority. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "request_quote",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "signature",
        "meaning": "Historical signature label/text only; never create signatureAuthority, authorized sender or a live signature assignment. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "stopped_by_ben",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      }
    ]
  },
  {
    "key": "reply_board_annotation",
    "source": "reply_board",
    "title": "ReplyBoardAnnotation",
    "fields": [
      {
        "key": "astra_notes",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "note",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "notes",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "offer",
        "meaning": "Correspondence offer prose, not a normalized company offer or automatic update to parent-owned offer model."
      }
    ]
  },
  {
    "key": "reply_board_attachments",
    "source": "reply_board",
    "title": "ReplyBoardAttachments",
    "fields": [
      {
        "key": "attachment",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "attachment_2",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "attachment_alternative",
        "meaning": "Alternative attachment list, not necessarily delivered files; empty list remains empty."
      },
      {
        "key": "attachment_paths",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "attachment_sha256",
        "meaning": "Unscoped source hash claim; do not assign it to an arbitrarily selected attachment."
      },
      {
        "key": "attachments",
        "meaning": "Observed array or text; preserve container tag, source order, duplicates and every original element; normalize only backed elements."
      }
    ]
  },
  {
    "key": "reply_board_addresses",
    "source": "reply_board",
    "title": "ReplyBoardAddresses",
    "fields": [
      {
        "key": "bcc",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "cc",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "from",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "to",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "reply_board_delivery",
    "source": "reply_board",
    "title": "ReplyBoardDelivery",
    "fields": [
      {
        "key": "bounced",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "bounced_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "delivery_unclear",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "sent_verification",
        "meaning": "Object observed; no complete nested schema found in inspected maintained writers. Preserve exact object, optional evidence projection only after explicit shape evidence. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "sent_verified",
        "meaning": "Boolean or text assertion; never silently elevate to provider-confirmed delivery. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "sent_verified_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "verification_method",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "verified_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      }
    ]
  },
  {
    "key": "reply_board_dispatch",
    "source": "reply_board",
    "title": "ReplyBoardDispatch",
    "fields": [
      {
        "key": "channel",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "continuity_dispatch_state",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "continuity_receipt",
        "meaning": "Archive code-supported receipt variants and unknown members; review/challenge evidence is not sending or delivery proof. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "orig_account",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "send_attempted",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "send_method",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "sent_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "sent_mailbox",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "sent_message_id",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "sent_on_authority_of",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "sent_via",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      }
    ]
  },
  {
    "key": "reply_board_parties",
    "source": "reply_board",
    "title": "ReplyBoardParties",
    "fields": [
      {
        "key": "company",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "contact",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "name",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "reply_board_draft",
    "source": "reply_board",
    "title": "ReplyBoardDraft",
    "fields": [
      {
        "key": "created_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "edited_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "id",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "kind",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "lang",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "previous_reply",
        "meaning": "Explicit prior reply text only; no fabricated author/time/intermediate revision chain."
      },
      {
        "key": "reply",
        "meaning": "Exact draft body, never inferred actual sent body; even status sent does not prove unchanged final envelope/body."
      },
      {
        "key": "staged",
        "meaning": "Observed boolean or text; keep type and literal, do not coerce into live staged status."
      },
      {
        "key": "status",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "subject",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "subject_override",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "suggested",
        "meaning": "Separate suggestion text with its own provenance; not an alias for suggested_reply."
      },
      {
        "key": "suggested_reply",
        "meaning": "Separate suggestion slot; never overwrite reply or interpret as a sent message."
      },
      {
        "key": "terms_changed",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "to_override",
        "meaning": "Boolean recipient override history, not an address string or present permission to change recipients."
      }
    ]
  },
  {
    "key": "reply_board_references",
    "source": "reply_board",
    "title": "ReplyBoardReferences",
    "fields": [
      {
        "key": "deal_id",
        "meaning": "Original deal label/identifier in separate namespace; not proof of company ID or physical-site ID."
      },
      {
        "key": "sites",
        "meaning": "Ordered array elements; element schema unestablished here. Resolve only explicit typed source-site IDs with exact mapping; labels remain unresolved."
      }
    ]
  },
  {
    "key": "reply_board_history",
    "source": "reply_board",
    "title": "ReplyBoardHistory",
    "fields": [
      {
        "key": "history",
        "meaning": "Ordered authentic source history payload; element schema not established by inventory. Preserve every element/null/extension; no guessed complete revisions."
      }
    ]
  },
  {
    "key": "reply_board_participants",
    "source": "reply_board",
    "title": "ReplyBoardParticipants",
    "fields": [
      {
        "key": "history_participants",
        "meaning": "Known code consumes a list of addresses, but actual element types were not inventoried. Archive original array; optional parsed historical participant evidence, never active recipients."
      }
    ]
  },
  {
    "key": "reply_board_message",
    "source": "reply_board",
    "title": "ReplyBoardMessage",
    "fields": [
      {
        "key": "mail_id",
        "meaning": "Integer local-mail locator, nullable; not a provider ID and not an inbound_emails UUID."
      },
      {
        "key": "message_id",
        "meaning": "Independent identifier claim with source spelling; role/namespace unresolved until evidence establishes it."
      },
      {
        "key": "received",
        "meaning": "Free-text received label (may be prose/compound), not a guaranteed timestamp."
      },
      {
        "key": "their_message",
        "meaning": "Recorded original-message text/fragment; sender/time are unknown unless independently evidenced. Outgoing from does not identify its author."
      },
      {
        "key": "their_message_id",
        "meaning": "Recorded intended reply-parent identifier; exact claim only, not a fabricated linked parent or provider UID."
      },
      {
        "key": "their_msgid",
        "meaning": "Independent rare source spelling; retain conflict with their_message_id rather than replacing it."
      }
    ]
  },
  {
    "key": "sent_ledger_dispatch",
    "source": "sent_ledger",
    "title": "SentLedgerDispatch",
    "fields": [
      {
        "key": "continuity_receipt",
        "meaning": "Independent event-time receipt archive, not replaced by newest card receipt. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "id",
        "meaning": "Card reference equals reply_board.id in the same source instance when exactly matched; NOT a unique ledger-event ID. Unmatched events retained. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "key",
        "meaning": "Legacy truncated SHA-256 letter fingerprint over stripped to/cc/subject/reply joined by U+001F; excludes sender/signature/files; never a primary key, credential, or delivery proof. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "note",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "phase",
        "meaning": "Local claimed/sent/not_dispatched or unknown phase assertion; retain chronological occurrence order and repeats; never provider delivery state. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "recorded",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "seeded",
        "meaning": "Seed/reconstruction label; retain separately, not an actual independent send/provider event. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "subject",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "t",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "to",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      },
      {
        "key": "via",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. NEVER create a live approval, signature authority, send job, queue, credential, schedule or delivery intent."
      }
    ]
  },
  {
    "key": "sent_ledger_delivery",
    "source": "sent_ledger",
    "title": "SentLedgerDelivery",
    "fields": [
      {
        "key": "evidence",
        "meaning": "Source evidence text claim only; does not establish recipient delivery. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "sent_message_id",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      },
      {
        "key": "verification_path",
        "meaning": "Private evidence locator metadata only; not opened or treated as retrieved/verified bytes. Evidence class defaults to local_source_assertion, not provider_confirmed_delivery."
      }
    ]
  },
  {
    "key": "inbound_emails_references",
    "source": "inbound_emails",
    "title": "InboundEmailsReferences",
    "fields": [
      {
        "key": "action_id",
        "meaning": "Explicit filing output reference to actions.id; preserve unresolved link, never create an executable action."
      },
      {
        "key": "comment_id",
        "meaning": "Explicit filing output reference to comments.id, not message identity equivalence."
      },
      {
        "key": "company_id",
        "meaning": "Recorded source filing association, not independent company verification."
      },
      {
        "key": "thread_ids",
        "meaning": "Ordered source-normalized In-Reply-To/References tokens, not a conversation ID or guaranteed parent relation."
      }
    ]
  },
  {
    "key": "inbound_emails_message",
    "source": "inbound_emails",
    "title": "InboundEmailsMessage",
    "fields": [
      {
        "key": "body",
        "meaning": "Source readableEvidence contains four headers plus decoded body and may be cutTo MAX_MAIL_CHARS. Not necessarily only original plain body."
      },
      {
        "key": "id",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "message_id",
        "meaning": "Source dedupe ID can be synthetic (source readMessage fallback). Preserve as dedupe claim; RFC header ID is separate nullable proof-backed field."
      },
      {
        "key": "raw",
        "meaning": "Source may cutTo MAX_RAW_CHARS and decode bytes to UTF-8; retained text is not guaranteed complete original MIME bytes."
      },
      {
        "key": "received_at",
        "meaning": "Source ingestion readAt, distinct from server receipt/provider delivery time; preserve exact source semantics."
      },
      {
        "key": "sent_at",
        "meaning": "Source-parsed Date evidence may be missing/wrong; do not synthesize from received_at."
      },
      {
        "key": "subject",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "inbound_emails_history",
    "source": "inbound_emails",
    "title": "InboundEmailsHistory",
    "fields": [
      {
        "key": "created_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "updated_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "inbound_emails_filing",
    "source": "inbound_emails",
    "title": "InboundEmailsFiling",
    "fields": [
      {
        "key": "filed_at",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "filed_by",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "match_method",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "nature",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "state",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  },
  {
    "key": "inbound_emails_addresses",
    "source": "inbound_emails",
    "title": "InboundEmailsAddresses",
    "fields": [
      {
        "key": "from_email",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "from_name",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      },
      {
        "key": "to_emails",
        "meaning": "Keep exact named source slot and presence/type; no coalescing of similarly named fields; archival only."
      }
    ]
  }
] as const;
